import { connect } from "react-redux";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { getAllScheduledJob, upsertScheduledJobAsync } from "../../../../redux/thunks/HomeThunks";
import { Dispatch } from "redux";
import IAppState from "../../../../redux/types/IAppState";
import TextDataInput from "../../textDataInput/TextDataInput";
import { SCHEDULE } from "../../../Consts";
import React from "react";
import ActionButton from "../../actionButton/ActionButton";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { IMembersPortalStateKeys } from "../../../../membersportal/types/IMembersPortalStateKeys";
import { ScheduledJob } from "../../../../redux/types/ScheduledJob";
import { SizedTextDisplay } from "../../../../core/components/textDisplay/TextDisplay";
import { showYesNoPrompt } from "../../../../redux/reducers/ModalReducer";
import { IYesNoPromptViewModalProps } from "../yesNoPromptView/YesNoPromptView";


export interface IScheduledJobsModalViewProps {
    hideModal: () => void;
    scheduledJob: ScheduledJob;
};


export interface IStateProps {scheduledJob: ScheduledJob, upsertScheduledJobAsync: (scheduledJob: any) => Promise<any>, lookupsValues: any, isScheduleJobLoading: boolean, getAllScheduledJob: () => void};

type IEditScheduledJobsModalViewConnectProps = IScheduledJobsModalViewProps & IStateProps;
const EditScheduledJobsModalView: React.FC<IEditScheduledJobsModalViewConnectProps> = ({
    scheduledJob,
    hideModal,
    upsertScheduledJobAsync,
    lookupsValues,
    isScheduleJobLoading,
    getAllScheduledJob
}) => {
    const [schedule, setSchedule] = React.useState(scheduledJob?.cronSchedule || '');
    const [scheduleError, setScheduleError] = React.useState(null);

    React.useEffect(() => {
        if(scheduledJob) {
            setSchedule(scheduledJob?.cronSchedule);
        }
    }, [scheduledJob, scheduledJob?.cronSchedule]);

    const handleScheduleChange = (value: string | boolean | number, fieldName: IRepertoireStateKeys | IMembersPortalStateKeys, isOnBlur?: boolean, index?: number) => {
        setSchedule(typeof value === 'string' ? value : '');
        setScheduleError(null);
    }

    const saveSchedule = () => {
        const valid = isValidCron(schedule);
        if (valid) {
            upsertScheduledJobAsync({...scheduledJob, cronSchedule: schedule}).then(() => {
                getAllScheduledJob();
            });
            setScheduleError(null);
        } else {
            setScheduleError('Invalid cron expression');
        }
    }

    const isValidCron = (cron: string): boolean => {
        const parts = cron.trim().split(/\s+/);
        if (parts.length !== 5 && parts.length !== 6) return false;

        const validators = [
            { name: 'second', regex: /^(\*|([0-5]?\d)(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ }, // optional
            { name: 'minute', regex: /^(\*|([0-5]?\d)(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'hour', regex: /^(\*|([01]?\d|2[0-3])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'dayOfMonth', regex: /^(\*|([1-9]|[12]\d|3[01])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'month', regex: /^(\*|(1[0-2]|0?[1-9])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'dayOfWeek', regex: /^(\*|[0-6](\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ }
        ];

        const offset = parts.length === 5 ? 1 : 0;

        return parts.every((part, i) => validators[i + offset].regex.test(part));
    }
    
    const getJobTypeDescription = (jobType: string) => {
        const jobTypeLookup = lookupsValues?.JobType?.lookups.find(x => x.code === jobType);
        return jobTypeLookup ? jobTypeLookup.description : '';
    }



    return (<div className="modal-dialog modalLarge settingsModal">
                <div className={"modal-content"}>
                    <div className='modal-header' style={{
                           background: "#38429C",
                           color: "white",
                    }}>
                        <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={() => hideModal()}>
                            <Dismiss20Regular title="Close" />
                        </button>
                            <h1 className="modal-title">{'Edit Scheduled Jobs'}</h1> 
                    </div>
                            <div className="modal-body" >
                                                {scheduleError && (
                                    <div className="alert alert-danger alert-dismissible">
                                        <span>{scheduleError}</span>
                                        <button type="button" className="close" aria-label="Close" onClick={() => setScheduleError(null)}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                )}
                                <div className="row tableContainer flexWrapRow flexJustifyContentCenter">
                                                   <SizedTextDisplay
                                                        label={'Scheduled Job Type'}
                                                        fieldName={'Scheduled Job Type'}
                                                        value={`${scheduledJob?.type} - ${getJobTypeDescription(scheduledJob?.type)}`}
                                                        isHidden={false}
                                                    />
                                                    <SizedTextDisplay
                                                        label={'Parameters'}
                                                        fieldName={'Parameters'}
                                                        value={scheduledJob?.parameters}
                                                        isHidden={false}
                                                    />
                                                    <SizedTextDisplay
                                                        label={'Last Run Date'}
                                                        fieldName={'Last Run Date'}
                                                        value={scheduledJob?.lastRunDate}
                                                        isHidden={false}
                                                    />
                                                       <div className="form-group fullWidth col-md-4 col-sm-6 col-xs-12 flexRow flexJustifyContentLeft">
                                                           <TextDataInput
                                                               label={SCHEDULE}
                                                               fieldName={SCHEDULE}
                                                               changeData={handleScheduleChange}
                                                               value={schedule}
                                                               isHidden={false}
                                                               isMandatory={false}
                                                               readOnly={false}
                                                           />
                                                           <div className="flexRow flexJustifyContentCenter" style={{ marginTop: "13px" }}>
                                                               <ActionButton
                                                                   buttonText={isScheduleJobLoading ? "Loading..." : "Set"}
                                                                   buttonAction={saveSchedule}
                                                                   disabled={!schedule || isScheduleJobLoading} />
                                                           </div>
                                                   </div>
                                </div>
                                <div className="row flexRow flexJustifyContentRight">
                                        <div className="form-group col-sm-12 margin-topSmall alignRight" style={{width: '300px'}}>
                                            <button className="button buttonAutowidth btn-defaultSecondary margin-rightMedium" onClick={() => hideModal()}>{"Dismiss"}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>)
}

export default connect((state: IAppState, props: IScheduledJobsModalViewProps) => ({
    lookupsValues: state.lookupEntities,
    isScheduleJobLoading: state.home.isScheduleJobLoading,
}),
    (dispatch: Dispatch) => ({
        upsertScheduledJobAsync: (scheduledJob: any) => dispatch<any>(upsertScheduledJobAsync(scheduledJob)),
        getAllScheduledJob: () => dispatch<any>(getAllScheduledJob()),
             
        showYesNoPrompt: (title: string, props: IYesNoPromptViewModalProps, message?: string, detailMessage?: string) =>
                    dispatch(showYesNoPrompt(title, props, message, detailMessage)),
    })
)(EditScheduledJobsModalView);